import React, { useState, useEffect }  from 'react';
import FormNew from './FormNew';
import { GetRequest, PostRequest } from 'components/common/index.js';

const List = ( { defaultUnit = 'mm' } ) => {
  const getInitialState = () => {
    const path = window.location.pathname;
    const editMatch = path.match(/\/quote-builder\/widgets\/([^/]+)\/edit/);
    if (editMatch) {
      return { mode: 'edit', identifier: editMatch[1] };
    }
    if (path.includes('/quote-builder/widgets/new')) {
      return { mode: 'new', identifier: '' };
    }
    return { mode: 'listing', identifier: '' };
  };

  const initialState = getInitialState();
  const [mode, setMode] = useState(initialState.mode)
  const [widgets, setWidgets] = useState([])
  const [identifier, setIdentifier] = useState(initialState.identifier)

  const widgetRow = (widget) => {
    return <tr key={widget.identifier}>
      <td> {widget.identifier} </td>
      <td> {widget.domains.join(',')} </td>
      <td> <a href={`/quote-builder/widgets/${widget.identifier}/preview`}> <i className="fa fa-eye" aria-hidden="true"></i> {t('quote_builder_widget.preview')} </a> </td>
      <td> <a href="#" onClick={(e) => showEditForm(e, widget.identifier) }> <i className="fa fa-pencil-square-o" aria-hidden="true"></i> {t('quote_builder_widget.edit')} </a> </td>
      <td> <a href="#" onClick={(e) => deleteConfirm(e, widget.identifier)}> <i className="fa fa-trash" aria-hidden="true"></i> {t('quote_builder_widget.delete')} </a> </td>
    </tr>
  }
  const listofItems = () => {
    return <table className="table table-striped table-bordered-outside quote_builder_table">
      <tbody>
        <tr>
          <th colSpan="5"> {t('quote_builder_widget.my_widgets')} ({widgets.length})  </th>
        </tr>

        <tr>
          <th> {t('quote_builder_widget.identifier')} </th>
          <th> {t('quote_builder_widget.domains')} </th>
          <th colSpan="3"></th>
        </tr>

        { widgets.map(widgetRow) }

      </tbody>
    </table>
  }

  const fetchWidgets = () => {
    if(mode != 'listing') { return }

    GetRequest({
      url: '/quote-builder/user-quote-builder-widgets',
      callback: (data) => {
        setWidgets( (_prev) => data );
      }
    })
  }

  const listofWidgets = () => {
    return (<>
      { widgets.length > 0 && listofItems() }

      <button onClick={showNewForm} className="btn simple-btn">
        <i className="fa fa-plus-square-o" aria-hidden="true"></i>
        <span> &nbsp; {t('quote_builder_widget.new_widget')} </span>
      </button>
      </>)
  }

  const showEditForm = (e, widgetIdentifier) => {
    e.preventDefault();
    window.history.pushState({}, '', `/quote-builder/widgets/${widgetIdentifier}/edit`);
    setIdentifier(() => widgetIdentifier);
    setMode(() => 'edit');
  };

  const showNewForm = () => {
    window.history.pushState({}, '', '/quote-builder/widgets/new');
    setMode(() => 'new');
  };

  const goToListing = () => {
    window.history.pushState({}, '', '/quote-builder/widgets');
    setMode(() => 'listing');
  }

  const deleteConfirm = (e, identifier) => {
    if(confirm( t('quote_builder_widget.delete_widget_confirm') )) {

    PostRequest({
      url: '/quote-builder/user-quote-builder-widgets-delete',
      data: {
        identifier: identifier,
      },
      callback: ( data ) => {
        setMode( () => 'listing' )
        setIdentifier( () => '' )
        fetchWidgets();
      },
      400: (data) => {
        setErrorMessage( () => data.error )
      }
    })

    }
  }

  const handlePopState = () => {
    const newState = getInitialState();
    setMode(newState.mode);
    setIdentifier(newState.identifier);
  };

  // useEffect
  useEffect(fetchWidgets, [mode]);

  useEffect(() => {
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  // useEffect

  return (
    <div style={{ marginLeft: '-20px' }}>
      {mode == 'listing' && listofWidgets()}
      {mode == 'new' && <FormNew setMode={goToListing} defaultUnit={defaultUnit} /> }
      {mode == 'edit' && <FormNew identifier={identifier} setMode={goToListing} defaultUnit={defaultUnit} /> }
    </div>
  )
}

export default List;
